import { AmenitiesTypeEnum } from '../enums';

export interface AmenityInterface {
  id?: string;
  iconKey: string;
  type: AmenitiesTypeEnum;
}
